import { render } from "./Party.vue?vue&type=template&id=07c071f3&scoped=true"
import script from "./Party.vue?vue&type=script&lang=js"
export * from "./Party.vue?vue&type=script&lang=js"

import "./Party.vue?vue&type=style&index=0&id=07c071f3&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c071f3"]])

export default __exports__